import {buscador,url} from "./mapListener";

export const final = function finalStep(evt){

    document.querySelector("body").classList.add("lock")
    document.querySelector(".loading-container").classList.remove("hidden-alert")

    var formData = new FormData();

    formData.append("firstName",document.getElementById("nombre").value)
    formData.append("lastName",document.getElementById("ap_paterno").value+
        " "+document.getElementById("ap_materno").value)
    formData.append("email",document.getElementById("email").value)
    formData.append("phone",document.getElementById("telefono").value)
    formData.append("min",JSON.parse(localStorage.getItem("result")).min)
    formData.append("max",JSON.parse(localStorage.getItem("result")).max)
    formData.append("table",JSON.parse(localStorage.getItem("result")).table)
    formData.append("id",buscador.get("id"));

    if (localStorage.getItem("type")!= null){
        formData.append("type",localStorage.getItem("type"))
    }
    if (localStorage.getItem("deal")!= null){
        formData.append("deal",localStorage.getItem("deal"))
    }
    if (localStorage.getItem("invitado")!= null){
        formData.append("invitado",localStorage.getItem("invitado"))
    }

    if (buscador.get("utm_campaign") != null){
        formData.append("71", buscador.get("utm_campaign"))
    }

    if (buscador.get("utm_source") != null){
        formData.append("72", buscador.get("utm_source"))
    }

    if (buscador.get("utm_medium") != null){
        formData.append("73", buscador.get("utm_medium"))
    }

    if (buscador.get("utm_content") != null){
        formData.append("74", buscador.get("utm_content"))
    }

    if (buscador.get("utm_term") != null){
        formData.append("101", buscador.get("utm_term"))
    }


    document.querySelectorAll(".step-3 input").forEach(element=>{
        formData.append(element.id,element.value);
    })

    formData.append("92",document.querySelector(".total").getAttribute("price"))
    formData.append("currency",document.querySelector(".total").getAttribute("currency"))
    formData.append("event_name",document.querySelector(".total").getAttribute("event_name"))

    fetch("https://api.savethechildrenmx.org/events_api/saveDatas.php",{
        method:'POST',
        body:formData
    }).then(resp=>{
        return resp.text()
    }).then(txt=>{
        // console.log(txt)
        var data = JSON.parse(txt)

        localStorage.setItem("payment_result",txt);
        localStorage.setItem("deal",data.deal);

        window.scroll(0,0)
        document.querySelector(".loading-container").classList.add("hidden-alert")
        console.log(data)
        if (data.status == 100){
            localStorage.setItem("type",data.type);
            document.querySelector(".secure").classList.remove("d-none")
            document.querySelector(".payment-error.error").classList.add("d-none");
            document.querySelector(".alert-container").classList.remove("hidden-alert")
            window.open(data.redirect_to,"3D secure","width=300, height=200");
        }
        if(data.status == 500){
            localStorage.setItem("type",data.type);
            document.querySelector(".mensaje-error").textContent = data.message
            document.querySelector(".payment-error.secure").classList.add("d-none");
             document.querySelector(".alert-container").classList.remove("hidden-alert")
        }

        if (data.status == 200){
            localStorage.setItem("st_id",data.st_id)
            document.querySelector(".success-container").classList.remove("hidden-alert")
        }

        document.querySelector("body").classList.add("lock")
    })
}

export const verifyInformation= function validateInformation(e){
    var formData = new FormData();

    formData.append("firstName",document.getElementById("nombre").value)
    formData.append("lastName",document.getElementById("ap_paterno").value+
        " "+document.getElementById("ap_materno").value)
    formData.append("email",document.getElementById("email").value)
    formData.append("phone",document.getElementById("telefono").value)
    formData.append("min",JSON.parse(localStorage.getItem("result")).min)
    formData.append("max",JSON.parse(localStorage.getItem("result")).max)
    formData.append("table",JSON.parse(localStorage.getItem("result")).table)
    formData.append("id",buscador.get("id"));
    formData.append("payment_intent",JSON.parse(localStorage.getItem("payment_result")).payment_intent)
    formData.append("deal",localStorage.getItem("deal"))



    document.querySelectorAll(".step-3 input").forEach(element=>{
        formData.append(element.id,element.value);
    })

    formData.append("92",document.querySelector(".total").textContent)


    fetch("https://api.savethechildrenmx.org/events_api/validateInformation.php",{
        method:'POST',
        body:formData
    }).then(resp=>{
        return resp.text()
    }).then(txt=>{
        var storage = JSON.parse(localStorage.getItem("payment_result"))
        var data = JSON.parse(txt)

        storage.st_id = data.st_id
        storage.status = data.status
        localStorage.setItem("st_id", data.st_id)

        localStorage.setItem("payment_result",JSON.stringify(storage))

        if (data.status == 200){
            document.querySelector(".alert-container").classList.add("hidden-alert")
            document.querySelector(".success-container").classList.remove("hidden-alert")
        }else{
            document.querySelector(".secure").classList.add("d-none")
            document.querySelector(".payment-error.error").classList.remove("d-none")
            document.querySelector(".mensaje-error").textContent = data.message
        }
    })
}

export const pass3 = function Pass3(){

    var formData = new FormData();
    formData.append("id",buscador.get("id"))
    formData.append("email",document.getElementById("email").value)

    document.querySelector(".step-2").classList.add("hide")
    document.querySelector(".step-3").classList.remove("hide")

    document.querySelector(".step-3 .details").innerHTML =
        document.querySelector(".step-2 .details").innerHTML

    document.querySelector(".step-3 .button-group button").setAttribute("disabled","disabled")
    document.querySelector(".step-3 .button-group button").classList.add("disabled")

    fetch("https://api.savethechildrenmx.org/events_api/getDeal.php",{
        method:'POST',
        body: formData
    }).then(resp=>{
        return resp.text()
    }).then(txt=>{
        var data = JSON.parse(txt);

        if (data.status == 200) {
            localStorage.setItem("deal",data.deal);
            localStorage.setItem("invitado",1);
        }
    })
}


// WEBPACK FOOTER //
// ./src/plugins/syncDatas.js